// Promo 6 — "The Stack" (partner discount codes)
import { PromoStage, BgPhoto, PHOTOS, FULL_PB } from "@/pages/promo/_stage";
import { motion } from "framer-motion";

const PARTNERS = [
  { name: "Bucked Up", code: "SLAY15", offer: "15% off" },
  { name: "VTL Apparel", code: "SLAY10", offer: "10% off" },
  { name: "Psycho Pharma", code: "SLAY20", offer: "20% off" },
  { name: "Built Bar", code: "SLAYBAR", offer: "10% off" },
  { name: "Legion", code: "SLAYFUEL", offer: "20% off" },
  { name: "Naked Nutrition", code: "SLAYNAK", offer: "15% off" },
];

const SLIDES = [
  {
    id: "open",
    duration: 2000,
    bg: "#FF1B91",
    render: () => (
      <div className="flex flex-col items-center justify-center w-full h-full text-center">
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.4 }} className="text-white uppercase tracking-[0.5em] text-sm font-bold mb-8">
          / Members only
        </motion.p>
        <motion.h1 initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.7 }} className="font-display font-black uppercase text-white leading-[0.85] tracking-tighter" style={{ fontSize: "200px" }}>
          The<br />
          <span className="font-brush font-normal normal-case -rotate-3 inline-block" style={{ fontSize: "230px" }}>perk</span><br />
          stack.
        </motion.h1>
      </div>
    ),
  },
  {
    id: "value",
    duration: 2000,
    bg: "#0A0A0A",
    render: () => (
      <div className="flex flex-col justify-center w-full h-full">
        <motion.p initial={{ opacity: 0, x: -30 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.4 }} className="text-[#FF1B91] uppercase tracking-[0.4em] text-sm font-bold mb-8">
          / On me
        </motion.p>
        <motion.h2 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.55, delay: 0.15 }} className="font-display font-black uppercase text-white leading-[0.9] tracking-tighter" style={{ fontSize: "130px" }}>
          6 brands.<br />
          <span className="text-[#FF1B91]">My codes.</span><br />
          Your wallet.
        </motion.h2>
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5, delay: 0.55 }} className="mt-8 text-white/65 text-2xl leading-snug">
          Stack the supps + apparel deals members get.
        </motion.p>
      </div>
    ),
  },
  {
    id: "grid",
    duration: 3600,
    bg: "#0A0A0A",
    render: () => (
      <div className="flex flex-col justify-center w-full h-full">
        <motion.p initial={{ opacity: 0, x: -30 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.4 }} className="text-[#FF1B91] uppercase tracking-[0.4em] text-sm font-bold mb-6">
          / Your codes
        </motion.p>
        <div className="grid grid-cols-2 gap-3">
          {PARTNERS.map((p, i) => (
            <motion.div
              key={p.code}
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.2 + i * 0.12 }}
              className="border border-[#FF1B91]/40 bg-[#FF1B91]/5 p-4"
            >
              <p className="text-white/55 text-[10px] uppercase tracking-[0.3em] font-bold">{p.offer}</p>
              <p className="font-display font-black uppercase text-white text-2xl tracking-tighter leading-none mt-1">{p.name}</p>
              <p className="font-display font-black text-[#FF1B91] text-xl tracking-tighter mt-2">CODE: {p.code}</p>
            </motion.div>
          ))}
        </div>
      </div>
    ),
  },
  {
    id: "math",
    duration: 2000,
    bg: "#FF1B91",
    render: () => (
      <div className="flex flex-col items-center justify-center w-full h-full text-center">
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.4 }} className="text-white uppercase tracking-[0.5em] text-base font-bold mb-6">
          / Average stack
        </motion.p>
        <motion.h2 initial={{ opacity: 0, scale: 0.85 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.55, delay: 0.15 }} className="font-display font-black uppercase text-white leading-[0.85] tracking-tighter" style={{ fontSize: "260px" }}>
          $200+<br />
          <span className="font-brush font-normal normal-case -rotate-3 inline-block" style={{ fontSize: "200px" }}>saved</span>
        </motion.h2>
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5, delay: 0.55 }} className="mt-6 text-white text-2xl font-bold uppercase tracking-tight">
          Most members, in year one.
        </motion.p>
      </div>
    ),
  },
  {
    id: "cta",
    duration: 5400,
    bg: "#0A0A0A",
    full: true,
    render: () => (
      <>
        <BgPhoto src={PHOTOS.social} kenBurns="in" />
        <div className="absolute inset-0 bg-black/70" />
        <div className="absolute inset-0 flex flex-col items-center justify-center px-16 text-center">
          <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.4 }} className="text-[#FF1B91] uppercase tracking-[0.4em] text-sm font-bold mb-8">
            / Unlock the stack
          </motion.p>
          <motion.h2 initial={{ opacity: 0, scale: 0.92 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.6, delay: 0.15 }} className="font-display font-black uppercase text-white leading-[0.85] tracking-tighter" style={{ fontSize: "180px" }}>
            Join.<br />
            <span className="font-brush font-normal normal-case text-[#FF1B91] -rotate-3 inline-block" style={{ fontSize: "200px" }}>Save.</span><br />
            Slay.
          </motion.h2>
          <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5, delay: 0.7 }} className="mt-10 text-white text-3xl font-bold tracking-tight">
            sweatwithslay.com
          </motion.p>
        </div>
      </>
    ),
  },
];

export default function Promo6() { return <PromoStage slides={SLIDES} />; }
